/**
 * A simple value object representing an intention to purchase x qty of the given item.
 */
class ItemRequest {
    /**
     * @param {AbstractItem} item
     * @param {number} qty
     * @param {number} [price]
     */
    constructor(
        item,
        qty = 1,
        price = undefined,
    ) {
        /**
         * @type {AbstractItem}
         */
        this.item = item;

        /**
         * @type {number}
         */
        this.qty = qty;

        /**
         * The price of the item when the request in being made. The API accepts a price parameter.
         * This is separate to item.price and item.offlinePrice.
         *
         * @type {number}
         */
        this.price = price === undefined ? item.getPrice() : price;
    }

    clone() {
        return new ItemRequest(this.item, this.qty, this.price);
    }
}

module.exports = ItemRequest;
